import clsx from "clsx";
import React, { useState } from "react";
import { FilterSection } from "web/react/components/filter-redesign/filter-section";
import RoundedPill from "web/react/components/filter-redesign/rounded-pill";
import { useActiveFilters, useFilterSync } from "web/react/hooks/filters";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./active-filters.module.css";

const MAX_ACTIVE_FILTERS = 8;

export function ActiveFilters(): JSX.Element | null {
    const { filters, count } = useActiveFilters();
    const { onChange } = useFilterSync();

    const [isOpen, setIsOpen] = useState(false);

    return (
        <FilterSection title={`${gettext("feed.filters.active_filters_title")} (${count})`}>
            <ul className={styles.wrapper}>
                {filters?.map((filter, index) => (
                    <li
                        key={filter.id}
                        className={clsx({
                            [styles.hidden]: index >= MAX_ACTIVE_FILTERS && !isOpen,
                        })}
                    >
                        <RoundedPill
                            label={filter.label}
                            to={filter.url}
                            onClick={() => onChange(filter.url)}
                        />
                    </li>
                ))}
            </ul>
            {count && count > MAX_ACTIVE_FILTERS ? (
                <div className={styles.buttonContainer}>
                    <button className={styles.button} onClick={() => setIsOpen(!isOpen)}>
                        {isOpen ? gettext("general.show_less") : gettext("general.show_more")}
                    </button>
                </div>
            ) : null}
        </FilterSection>
    );
}
